import React from "react";
import "./style.scss";
import DesktopNavBarButton from "../../../features/NavBar/shared/SubpageNavBarButton";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useAuth from "../Login/hooks/useAuth";
import { LOGIN_PAGE } from "../../routes";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";

const MobileFirstScreen: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { isLoggedIn } = useAuth();

  const isActiveRoute = (link: string): boolean => {
    return location.pathname === link;
  };

  return (
    <React.Fragment>
      {saleConfiguration.componentList && (
        <div className="welcome-mobile">
          {saleConfiguration.componentList.map((item, index) => (
            <DesktopNavBarButton item={item} key={index} />
          ))}

          {saleConfiguration.allowToMakeAccount && (
            <Link to={LOGIN_PAGE}>
              <EAButton
                title={isLoggedIn ? t("moje_konto") : t("zaloguj_sie")}
                variant={isActiveRoute(LOGIN_PAGE) ? "filled" : "outlined"}
                fullWidth
              />
            </Link>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default MobileFirstScreen;
